import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Typography from '../../components/common/Typography';
import Button from '../../components/common/Button';
import { useNavigate } from 'react-router-dom';
import TextField from '../../components/common/TextField';
import { openAlert } from '../common/dialogSlice';
import { validatePassword } from '../myInfo/util';
import { HtmIDFindCertify, HtmPWChangeEnd } from './findByPasswordSlice';

const Step5 = ({ stepHandler }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('findPassword');
  const { t: tCommon } = useTranslation('common');
  const { idInfo } = useSelector(state => state.findByPassword);

  const [form, setForm] = useState({
    password: '',
    confirmPassword: '',
  });

  const handleChange = event => {
    const { name, value } = event.target;
    setForm(prevForm => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!form.password) {
      return {
        isValid: false,
        message: t('step5.placeholder.message1'), // 비밀번호를 입력해주세요
      };
    }

    if (!validatePassword(form.password)) {
      return {
        isValid: false,
        message: t('step5.placeholder.message4'), // 비밀번호 형식 오류
      };
    }

    if (!form.confirmPassword) {
      return {
        isValid: false,
        message: t('step5.placeholder.message3'), // 비밀번호 확인을 입력해주세요
      };
    }

    if (form.password !== form.confirmPassword) {
      return {
        isValid: false,
        message: t('step5.placeholder.message2'), // 비밀번호가 일치하지 않습니다
      };
    }

    return { isValid: true };
  };

  const handleConfirm = async () => {
    const validation = validateForm();

    if (!validation.isValid) {
      dispatch(
        openAlert({
          title: t('step5.alert.errorTitle', '확인해 주세요!'),
          description: validation.message,
          buttons: [
            {
              label: t('step5.alert.confirm', '확인'),
              actionType: 'CLOSE',
              color: 'white',
            },
          ],
        }),
      );
      return;
    }

    try {
      const response = await dispatch(
        HtmPWChangeEnd({
          htmMCd: idInfo.htmMCd,
          htmSCd: idInfo.htmSCd,
          htmComPass: form.password,
        }),
      ).unwrap();

      if (response.resultCode === 'OK') {
        dispatch(
          openAlert({
            title: t('step5.alert.title', '비밀번호가 변경되었어요.'),
            slice: 'findPassword',
            actionType: 'CANCEL',
            dialogType: 'alert',
            buttons: [
              {
                label: t('step5.alert.confirm', '확인'),
                actionType: 'PASS_TO_LOGIN',
                color: 'white',
              },
            ],
          }),
        );
      } else {
        dispatch(
          openAlert({
            title: t('step5.alert.errorTitle', '확인해 주세요!'),
            description: t('step5.alert.errorDescription', '비밀번호를 다시 확인해주세요.'),
          }),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    dispatch(
      openAlert({
        title: t('step5.alert.cancelTitle', '비밀번호 찾기 취소'),
        description: t(
          'step5.alert.cancelDescription',
          '비밀번호 찾기가 취소되었습니다.\n로그인 화면으로 돌아갑니다.',
        ),
        slice: 'findPassword',
        actionType: 'CANCEL',
        dialogType: 'alert',
        buttons: [
          {
            label: t('step5.alert.confirm', '확인'),
            actionType: 'PASS_TO_LOGIN',
            size: 'small',
          },
        ],
      }),
    );
  };

  return (
    <>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        <Typography variant="subtitleBold">{t('step5.title')}</Typography>
        <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
          {t('step5.description')}
        </Typography>
      </div>
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        <TextField
          variant="login"
          placeholder={t('step5.placeholder.password')}
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
        />
        <TextField
          variant="login"
          placeholder={t('step5.placeholder.passwordConfirm')}
          type="password"
          name="confirmPassword"
          value={form.confirmPassword}
          onChange={handleChange}
        />
      </div>
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        <Button value={tCommon('confirm')} fullWidth onClick={handleConfirm} />
        <Button color="sub" value={tCommon('cancel2')} fullWidth onClick={handleCancel} />
      </div>
    </>
  );
};

export default Step5;
